<template>
	<div>
		<div class="comment-box" v-for="item in items" v-parallax-fit="item.parallaxData">
			<div class="exhibit"><img :src="item.exhibit" /></div>
			<span v-html="item.text[store.lang]"></span>
		</div>
	</div>
</template>

<script>
import { store } from '../store';
export default {
	props: ['items'],
	data() {
		return {
			store
		};
	},
};
</script>

<style lang="scss" scoped>
.comment-box {
	min-width: 28%;
	max-width: 35%;
	position: fixed;
	padding: 15px 20px;
	opacity: 0.8;
	background-color: #000;
	border-radius: 25px;
	top: 40px;
	text-align: center;
	left: 55%;
	transition: 0.5s;
	transform: translateX(-50%);
	z-index: 20;
	user-select: none;
	pointer-events: none;

	span {
		color: #fff;
		font-family: 'american-typewriter', 'Courier New', Courier, monospace;
		font-size: 1.3rem;
		line-height: 1.8rem;
	}

	.exhibit {
		position: absolute;
		width: 175px;
		top: -50px;
		left: 50%;
		transform: translateX(-50%);

		@media(min-width: 600px) and (max-width: 1280px) {
			zoom: 1.3;
		}

		@media(max-width: 400px) {
			width: 125px;
			top: -37px;
		}
	}

	@media(max-width: 1920px) {
		span {
			font-size: 1.1rem;
			line-height: 1.6rem;
		}
	}

	@media(max-width: 1600px) {
		span {
			font-size: 1rem;
			line-height: 1.5rem;
		}
	}

	@media(min-width: 600px) and (max-width: 1280px) {
		zoom: 0.65;
	}

	@media(max-width:600px) {
		top: 23%;
		left: 50%;
		max-width: 85%;
		width: 85%;
		padding: 10px;
		line-height: 18px;

		span {
			font-size: 12px;
			line-height: 14px;
		}
	}

	@media(max-width: 400px) {
		top: 21%;
		max-width: 95%;
		width: 95%;
		line-height: 13px;
	}
}</style>
